let addDocumentRequestButton = document.querySelector('#add_document_request');

function removeElement(event) {
    event.preventDefault();
    let element = event.target;
    element.closest('[data-type=\'document_container\']').remove();
}

function toggleHideInput(element) {
    element.classList.toggle('hide');
    let input = element.querySelector('[data-type=\'input\']');
    input.value = '';
}

function toggleSearchCreateInputs(documentContainer) {
    let searchInput = documentContainer.querySelector('[data-type=\'search\']');
    let createInputs = documentContainer.querySelectorAll('[data-type=\'create\']');
    toggleHideInput(searchInput);
    createInputs.forEach((createInput) => {
        toggleHideInput(createInput);
    })
}

function addDocumentRequest() {
    let container = document.querySelector('#inputs-container');
    let document_container = addDocumentRequestButton.getAttribute('data-html')
    container.insertAdjacentHTML('beforeend', document_container)
    let removeButton = container.querySelector('[data-type=\'document_container\']:last-child [data-type="remove"]');
    removeButton.addEventListener('click', removeElement);
    let createSearchButton = container.querySelector('[data-type=\'document_container\']:last-child [data-type="create_search"]');
    createSearchButton.addEventListener('click', (event) => {
        let documentContainer = event.target.closest('[data-type=\'document_container\']');
        toggleSearchCreateInputs(documentContainer);
    });
}

addDocumentRequestButton.addEventListener('click', function (event) {
    event.preventDefault();
    addDocumentRequest();
})

if (requestedDocumentsAttributes != null) {
    requestedDocumentsAttributes.forEach((requestedDocumentAttrs) => {
        addDocumentRequest();
        let documentContainer = document.querySelector('#inputs-container [data-type=\'document_container\']:last-child');
        let rentDocumentAttributes = requestedDocumentAttrs.rent_document_attributes;
        if (!rentDocumentAttributes.id) {
            toggleSearchCreateInputs(documentContainer);
        }
        for (let key in rentDocumentAttributes) {
            if (rentDocumentAttributes.hasOwnProperty(key)) {
                let input = documentContainer.querySelector(`[data-field='${key}']`);
                input.value = rentDocumentAttributes[key];
            }
        }
    })
}
